import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import CostumerList from '../../../../views/CostumerList/CostumerList';

const CustomerListPageRoute = () => {
    return (
        <div>
            <Routes>
                <Route path="" element={<CostumerList />} />                
            </Routes>
        </div>
    );
};

export default CustomerListPageRoute;